<div
  class="udex-grid udex-mx-auto">
  <div class="row udex-pb-56 udex-pb-lg-84">
    <dcp-configurator-loading-stages-to-checkout></dcp-configurator-loading-stages-to-checkout>
  </div>
</div>
